import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

import {
  FaBrain, FaMicrochip, FaCogs,
  FaChartBar, FaNetworkWired,
  FaHeartbeat, FaSatelliteDish
} from 'react-icons/fa';

const services = [
  {
    icon: <FaBrain />,
    title: 'AI & ML',
    description: 'Advanced artificial intelligence and machine learning solutions',
    gradient: 'linear-gradient(to right, #00008B, #0000CD)',
  },
  {
    icon: <FaChartBar />,
    title: 'Data Analytics',
    description: 'Comprehensive data analysis and visualization',
    gradient: 'linear-gradient(to right, #6A0DAD, #8A2BE2)',
  },
  {
    icon: <FaMicrochip />,
    title: 'Embedded Systems & VLSI',
    description: 'Custom embedded solutions and VLSI design',
    gradient: 'linear-gradient(to right, #FF8C00, #FFA500)',
  },
  {
    icon: <FaCogs />,
    title: 'Control & Automation',
    description: 'Intelligent control systems and automation solutions',
    gradient: 'linear-gradient(to right, #006400, #228B22)',
  },
  {
    icon: <FaNetworkWired />,
    title: 'Computing & Networking/CMS',
    description: 'Advanced computing and networking solutions',
    gradient: 'linear-gradient(to right, #4B0082, #6A5ACD)',
  },
  {
    icon: <FaHeartbeat />,
    title: 'Bio & Medical Systems',
    description: 'Innovative biomedical technology solutions',
    gradient: 'linear-gradient(to right, #FFD700, #FFA500)',
  },
  {
    icon: <FaSatelliteDish />,
    title: 'Sensors & Interaction',
    description: 'Smart sensor systems and interaction technologies',
    gradient: 'linear-gradient(to right, #8B0000, #B22222)',
  },
];

const Services = () => {
  return (
    <section
      id="services"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{ textAlign: 'center', marginBottom: '50px' }}
      >
        <div
          style={{
            display: 'inline-block',
            background: '#007bff',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '24px',
            padding: '12px 35px',
            borderRadius: '25px',
            textTransform: 'uppercase',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          }}
        >
          Services
        </div>
        <h2
          style={{
            color: '#00008B',
            fontSize: '22px',
            marginTop: '20px',
            fontWeight: 'bold',
          }}
        >
          Check our Services
        </h2>
        <p
          style={{
            color: 'black',
            fontSize: '22px',
            fontWeight: 'bold',
            marginTop: '10px',
          }}
        >
          Discover a future where technology works for you
        </p>
      </motion.div>

      {/* Swiper Carousel */}
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={1.2}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            640: { slidesPerView: 2.5 },
            1024: { slidesPerView: 3.5 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                style={{
                  background: service.gradient,
                  padding: '20px 10px',
                  borderRadius: '20px',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                  margin: '20px',
                  minHeight: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.3s',
                }}
              >
                <div
                  style={{
                    width: '64px',
                    height: '64px',
                    background: 'white',
                    color: 'black',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    fontSize: '24px',
                    marginBottom: '15px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  }}
                >
                  {service.icon}
                </div>
                <h3
                  style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    color: 'white',
                    textAlign: 'center',
                    marginBottom: '10px',
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    fontSize: '18px',
                    color: 'white',
                    textAlign: 'center',
                    margin: 0,
                  }}
                >
                  {service.description}
                </p>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Services;
